import { CamposGenericos } from "./camposGenericos";

export class MotivoDevolucionNC extends CamposGenericos {
    cargo: string;
    descripcion: string;
    id: string;
    idCompania: string;
    idDivision: string;
    idPais: string;
    idSalesOrg: string;
    idTipoNC: string;
    tipoNC: string;
    nroPedidoRelacionado: boolean;
    wfAprobacion: boolean;
}